import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface PillGroupOption {
  value: string;
  label: ReactNode;
}

export interface PillGroupProps {
  label?: string;
  value: string;
  options: PillGroupOption[];
  onChange: (value: string) => void;
}

export const PillGroup = ({ label, value, options, onChange }: PillGroupProps) => {
  return (
    <div>
      {label && <label className="block text-xs font-bold text-body mb-2">{label}</label>}
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const selected = option.value === value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={cn(
                'px-4 py-2 rounded-full text-sm font-medium border transition-colors',
                selected
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'bg-surface text-body border-[var(--border-default)] hover:bg-blue-50 dark:hover:bg-blue-900/20'
              )}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
